var _defs, _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoProgressive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    height: 54,
    width: 456,
    viewBox: "0 0 456.21 54.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#FFFFFF;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-progressive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.81,30.52c4.9-.51,8.41-2.82,10.39-6.92,1.62-3.34,4.12-8.75,4.14-8.81,2.48-5.12,1.72-8.25.64-10-1.62-2.59-4.79-3.51-7.2-3.51H206.23l-25.41,54h12.76l9.73-21.21,6.84,0a3.87,3.87,0,0,1,2.9,1.59c.82,1.36.6,3.44-.69,6.18-3.08,6.61-5.53,13.46-5.53,13.46h12.94a29,29,0,0,1,1.57-5.22c1-2.36,4-9.82,4-9.89C227.81,34.14,224.75,31.72,222.81,30.52Zm-1.35-8.91c-1.08,2.28-2.74,3.44-4.95,3.44h-8.9l6.75-14.7h9.74a1.75,1.75,0,0,1,1.32.7c.39.64.25,1.71-.4,3.1l-2.23,4.68Z",
    transform: "translate(-1.27 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.61,30.52C91.51,30,95,27.69,97,23.59c1.62-3.34,4.12-8.75,4.15-8.81,2.48-5.12,1.72-8.25.64-10C100.17,2.23,97,1.31,94.58,1.31H70l-25.41,54H57.38l9.73-21.21,6.85,0a3.87,3.87,0,0,1,2.9,1.59c.83,1.36.6,3.44-.69,6.18-3.08,6.61-5.53,13.46-5.53,13.46H83.58a28.74,28.74,0,0,1,1.56-5.22c1-2.36,4-9.82,4-9.89C91.62,34.14,88.55,31.72,86.61,30.52ZM85.26,21.6C84.18,23.89,82.52,25,80.32,25h-8.9l6.94-14.7h9.54a1.75,1.75,0,0,1,1.32.7c.39.64.25,1.71-.4,3.1l-2.23,4.68Z",
    transform: "translate(-1.27 -1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.53,14.74C151,5.16,145.94,1,139.5,1H124c-6.52,0-11.12,3.08-14.08,9.41-1.59,3.4-4.24,9-7.31,15.39L96.13,39.46c-6.51,13.7,3.23,16,8,16h9.79c9.81.1,14.64-2.67,18.43-10.57,2.54-5.28,6.06-12.82,9.8-20.81ZM133.8,13.22l-13,27.69c-1.81,3.82-3,4.47-5.81,4.47h-5.62c-1,0-3-.27-1.5-3.54,2.18-4.7,11.32-24.4,13.19-28.36,1.27-2.7,2.59-3.24,4.31-3.24h7C133.7,10.18,134.89,10.91,133.8,13.22Z",
    transform: "translate(-1.27 -1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.79,25.33l-4.24,9h6.72l-3.78,8.17c-1.1,2.37-1.85,2.85-4.44,2.85h-6.68c-2,0-2.7-1-1.5-3.54,1.52-3.22,13.52-28.28,13.52-28.28,1.36-2.85,2.17-3.28,4.27-3.28h6.9c1.67,0,2.57.77,1.45,3-.25.49-3,6.5-3,6.5l12.17.09,2.77-5.95C196,5.19,192.38,1.12,184,1H170.78a16,16,0,0,0-15,9.41C153.37,15.54,142,39.46,142,39.46c-4.16,8.75-1.75,16,9.63,16h10.16c8.12.08,12.11-1.19,15.82-9.31l9.47-20.75Z",
    transform: "translate(-1.27 -1)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "349.96 0.14 324.52 54.22 337.63 54.22 363.23 0.14 349.96 0.14"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "395.73 0.15 366.04 47.79 381.06 0.15 367.31 0.15 354.71 54.22 372.45 54.22 409.52 0.15 395.73 0.15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.45,36.46l-1.1-20c-.13-2.41.46-5.68,4.87-5.68h8.86l4.55-9.64h-15.1c-12,0-16,7.31-15.57,15.9.28,5.25,1,22.33,1,22.33.18,4.12-1.4,6-5.25,6h-10.1l-4.53,9.81h16.1C289.86,55.24,296.15,48.27,295.45,36.46Z",
    transform: "translate(-1.27 -1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.54,16.48c-.13-2.41.46-5.68,4.87-5.68h8.86l4.55-9.64h-15.1c-9.92,0-16.14,5.42-15.57,15.9.29,5.25,1,22.33,1,22.33.19,4.12-1.39,6-5.25,6h-9.84l-4.53,9.81h15.84c11.74,0,16.88-8.4,16.26-18.78Z",
    transform: "translate(-1.27 -1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.43,31.05h16.41l4.21-9H254.58l5.24-11.22,17,0s4.46-9.59,4.46-9.59H251.66l-25.27,54h32L263,45.45H243.59Z",
    transform: "translate(-1.27 -1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.88,55.23h32l4.65-9.78H407.08l6.84-14.4h16.41l4.21-9H418.07l5.24-11.22,17,0s4.45-9.59,4.45-9.59H415.15Z",
    transform: "translate(-1.27 -1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.7,27.13c1.07-2.21,3.19-6.79,5.6-12.11,4.23-9.36-1-13.69-6.55-13.71H26.47L1.27,55.39h13.1l8.8-18.94s7.4,0,12.76,0C44.1,36.51,48.37,34,51.7,27.13ZM44.94,14.59c-2.36,5-4.16,8.74-4.36,9.15C39.52,26,38,27,35.71,27H27.49l7.77-16.83h8.24C45.31,10.18,46.6,11.09,44.94,14.59Z",
    transform: "translate(-1.27 -1)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.35,4.91a1.2,1.2,0,0,0-.55-1.06,2.28,2.28,0,0,0-1.2-.24h-2.14V8.53h.6V6.26h1.1l1.41,2.27h.71L453.8,6.26C454.67,6.24,455.35,5.88,455.35,4.91ZM453,5.79h-.92V4h1.41c.61,0,1.28.09,1.28.85C454.74,5.9,453.67,5.79,453,5.79Z",
    transform: "translate(-1.27 -1)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.1,1.67a4.4,4.4,0,1,0,4.39,4.39A4.4,4.4,0,0,0,453.1,1.67Zm0,8.27A3.87,3.87,0,1,1,457,6.07,3.87,3.87,0,0,1,453.1,9.95Z",
    transform: "translate(-1.27 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProgressive);
export default __webpack_public_path__ + "static/media/logo-progressive.bdb90d7bfac45c57d1d4e26f3f750f03.svg";
export { ForwardRef as ReactComponent };